import { Box, Typography, useTheme, Snackbar } from "@mui/joy";
import MuneyLogin from "../../components/icons/muneyLogin";
import CustomInput from "../../components/UI/custom_elements/customInput";
import PrimaryButton from "../../components/UI/custom_elements/primaryButton";
import { useNavigate } from "react-router-dom";
import Login1 from "../../components/icons/login/login_1";
import Login2 from "../../components/icons/login/login_2";
import Login3 from "../../components/icons/login/login_3";
import Login4 from "../../components/icons/login/login_4";
import { useContext, useState } from "react";
import SessionContext from "../../store";
import UIContext from "../../store/ui";
import axios from 'axios';

const Login = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setActualSession } = useContext(SessionContext);
    const { setMenuByUserType } = useContext(UIContext);

    const [credentials, setCredentials] = useState({
        username: "",   // email or username [#34]
        password: ""
    });

    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const showError = (message) => {
        setErrorMessage(message);
        setTimeout(() => { setErrorMessage(null); }, 5000);
    };

    const login = async () => {
        if (!credentials.username || !credentials.password) {
            showError("Todos los campos son obligatorios.");
            return;
        }

        try {
            setLoading(true);
            const result = await setActualSession(credentials, (userType) => {
                setMenuByUserType(userType);
            });
            
            if (result && result.token) {
                if (result.password_update_required) {
                    navigate("/change-password-required");
                } else {
                    navigate("/tx");
                }
            } else {
                setLoading(false);
                showError("Credenciales incorrectas.");
            }
        } catch (error) {
            setLoading(false);
            console.log("Error Login:", error);
            showError(error.message || "Error en el inicio de sesión.");
        }
    };

    const handleRecoverPassword = async () => {
        if (!credentials.username) {
            showError("Por favor ingrese su correo o usuario para recuperar la contraseña.");
            return;
        }

        try {
            setLoading(true);
            await axios.post(
                `${process.env.REACT_APP_URL_API}/orders/recover-password`,
                {
                    identifier: credentials.username
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            setSuccessMessage("Se ha enviado un correo con las instrucciones para recuperar su contraseña.");
        } catch (error) {
            console.log("Error Recover Password:", error);
            showError("Error al solicitar recuperación de contraseña. Por favor intente nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            login();
        }
    };

    return (
        <Box 
            sx={{
                width: "100vw", 
                height: "100dvh", 
                backgroundColor: theme.vars.palette.background.body, 
                position: "relative",
                overflow: "hidden"
            }}
            onKeyPress={handleKeyPress}
        >
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box sx={{position: "fixed"}}> <Login1 /> </Box>
                <Box sx={{position: "fixed", bottom: "0px"}}> <Login2 /> </Box>
                <Box sx={{position: "fixed", bottom: "164px", right: "0px"}}> <Login3 /> </Box>
                <Box sx={{position: "fixed", bottom: "0px", right: "0px"}}> <Login4 /> </Box>
            </Box>

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                zIndex: 10,
                position: "relative",
                p: 3,
                boxSizing: "border-box"
            }}>
                <Box sx={{ 
                    mb: 5, 
                    width: "100%", 
                    display: "flex", 
                    justifyContent: "center",
                    "& > svg": {
                        maxWidth: "100%",
                        height: "auto",
                        maxHeight: "150px"
                    }
                }}>
                    <Box display={{ xs: 'none', md: 'flex' }} sx={{ maxWidth: { xs: "200px", md: "100%" } }}>
                        <MuneyLogin />
                    </Box>
                </Box>
                
                <Box sx={{
                    width: "100%",
                    maxWidth: "566px",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <Box>
                        <Typography sx={{ fontFamily: "Montserrat", fontSize: "20px", fontWeight: 700, color: theme.vars.palette.text.main }}>
                            Inicio de sesión
                        </Typography>
                    </Box>

                    <Box mt={4}>
                        <CustomInput
                            placeholder="Correo o usuario"
                            width="100%"
                            setValue={(value) => setCredentials(prev => ({ ...prev, username: value }))}
                            value={credentials.username}
                        />
                    </Box>

                    <Box mt={2}>
                        <CustomInput
                            placeholder="Contraseña"
                            width="100%"
                            password={true}
                            setValue={(value) => setCredentials(prev => ({ ...prev, password: value }))}
                            value={credentials.password}
                        />
                    </Box>

                    <Box mt={4} width="100%">
                        <PrimaryButton click={login} text="Iniciar sesión" full={true} loading={loading} />
                    </Box>

                    <Box mt={2} width="100%">
                        <Typography 
                            onClick={handleRecoverPassword}
                            sx={{ 
                                fontFamily: "Montserrat", 
                                fontSize: "14px", 
                                color: theme.vars.palette.primary["500"],
                                textAlign: "center",
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                '&:hover': {
                                    color: theme.vars.palette.primary["600"]
                                }
                            }}
                        >
                            ¿Olvidaste tu contraseña?
                        </Typography>
                    </Box>

                    {errorMessage && (
                        <Box mt={2}>
                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "16px", color: 'red', textAlign: "center" }}>
                                {errorMessage}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            <Snackbar
                open={!!successMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                variant="solid"
                color="success"
                autoHideDuration={5000}
                onClose={() => setSuccessMessage(null)}
            >
                {successMessage}
            </Snackbar>
        </Box>
    );
};

export default Login;